import React, {useState} from 'react'
import { Flex } from "@chakra-ui/react";
import i18n from "../../../i18n/i18n";
import BodyText from "../../../components/Common/BodyText";
import { colors } from "../../../definitions/constants/GlobalStyles";
import ButtonComponent from "../../../components/Common/ButtonComponent";
import { SortIcon } from "../../../definitions/constants/IconsComponent";
import IconArrowShort from "../../../assets/icons/IconArrowShort";
import DetailsTournamentComponent from "./DetailsTournamentComponent";
import MatchesTournamentComponent from "./MatchesTournamentComponent";
import StandingsTournamentComponent from "./StandingsTournamentComponent";
import PlayersTournamentComponent from "./PlayersTournamentComponent";
import PlayOffsTournamentComponent from "./PlayOffsTournamentComponent";

const TournamentViewOtherComponent = () => {
  const [activeButton, setActiveButton] = useState("details");

  return (
    <>
      <Flex
        alignItems="flex-end"
        alignSelf="stretch"
        flexDirection="row"
        justifyContent="space-between"
        borderBottomWidth="1px"
      >
        <ButtonComponent
          variant="variantTab"
          buttonName="details"
          activeButton={activeButton}
          onClick={() => {
            setActiveButton("details");
          }}
        >
          {i18n.t("details")}
        </ButtonComponent>

        <ButtonComponent
          variant="variantTab"
          buttonName="playoffs"
          activeButton={activeButton}
          onClick={() => {
            setActiveButton("playoffs");
          }}
        >
          {i18n.t("playoffs")}
        </ButtonComponent>

        <ButtonComponent
          variant="variantTab"
          buttonName="matches"
          activeButton={activeButton}
          onClick={() => {
            setActiveButton("matches");
          }}
        >
          {i18n.t("matches")}
        </ButtonComponent>

        <ButtonComponent
          variant="variantTab"
          buttonName="classifications"
          activeButton={activeButton}
          onClick={() => {
            setActiveButton("classifications");
          }}
        >
          {i18n.t("classifications")}
        </ButtonComponent>

        <ButtonComponent
          variant="variantTab"
          buttonName="players"
          activeButton={activeButton}
          onClick={() => {
            setActiveButton("players");
          }}
        >
          {i18n.t("players")}
        </ButtonComponent>

        <Flex
          display="flex"
          flex="1"
          gap={2}
          alignItems="center"
          justifyContent="flex-end"
          alignSelf="center"
          flexDirection="row"
        >
          <SortIcon />

          <BodyText
            fontSize={{ base: "14px", md: "13px" }}
            fontWeight="semiBold"
            color={colors.text.black}
            textAlign="center"
          >
            {i18n.t("season")}: 2024
          </BodyText>

          <IconArrowShort />
        </Flex>
      </Flex>
      {activeButton === "details" && <DetailsTournamentComponent />}
      {activeButton === "playoffs" && <PlayOffsTournamentComponent />}
      {activeButton === "matches" && <MatchesTournamentComponent />}
      {activeButton === "classifications" && <StandingsTournamentComponent />}
      {activeButton === "players" && <PlayersTournamentComponent />}
    </>
  );
}

export default TournamentViewOtherComponent